import * as MeteringViewConstants from '../MeteringView/MeteringViewConstants';
import { produce } from "immer";
// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState ={
    meteringDataCountFetching: false,
    meteringDataCountFetching: false,
    meteringDataCountFetchedFailed: false,
    meteringDataCount: {},
    message:""
};

export default function MeteringViewDataCountReducer(state = initialState, action) {

    switch (action.type) {

        case MeteringViewConstants.METER_DATA_COUNT_FETCHING:{

            console.log("METER_DATA_COUNT_FETCHING");

             return assign({}, state, {
                    meteringDataCountFetching: true,
                    meteringDataCountFetched: false,
                    meteringDataCountFetchedFailed: false,
                    meteringDataCount: {},
                    message:""
            });
        }

        case MeteringViewConstants.METER_DATA_COUNT_FETCHED:{

            console.log("METER_DATA_COUNT_FETCHED"+JSON.stringify(action.payload.newState.result));
           
            return assign({}, state, {
                    meteringDataCountFetching: false,
                    meteringDataCountFetched: true,
                    meteringDataCountFetchedFailed: false,
                    meteringDataCount: action.payload.newState.result['METER_DATA_COUNT'],
                    message:action.payload.newState.result["MESSAGE"]
            });
        }

        case MeteringViewConstants.METER_DATA_COUNT_FETCHING_FAILED:{
           
            return assign({}, state, {
                    meteringDataCountFetching: false,
                    meteringDataCountFetched: false,
                    meteringDataCountFetchedFailed: true,
                    meteringDataCount: {},
                    message:""
            });
            return assign({}, state,newState);
        }
        
        case MeteringViewConstants.METER_DATA_COUNT_RESET:{
           
            return assign({}, state, {
                meteringDataCountFetching: false,
                meteringDataCountFetched: false,
                meteringDataCountFetchedFailed: false,
                meteringDataCount: {},
                message:""
            });
            return assign({}, state,newState);
        }
        

        break;   
        
        default:
        return state;

    }

}